module.exports = __webpack_public_path__ + "img/R06_S3.47ff0af7.svg";